import { axiosInstance } from "@/helper/axios";
import api from "@/api";

const EXCLUDED_UNIT_CODES = ["MLT", "GRM"];

const state = {
  unitCodes: {},
};

const getters = {
  getUnitCodes: (state) => (type) => {
    return state.unitCodes[type] || [];
  },
  getFilteredUnitCodes: (state) => (type, excludedCodes = EXCLUDED_UNIT_CODES) => {
    const all = state.unitCodes[type] || [];
    const excluded = new Set(excludedCodes);
    return all.filter((item) => !excluded.has(item.value));
  },
};

const mutations = {
  setUnitCodes(state, { type, unitCodes }) {
    state.unitCodes[type] = unitCodes;
  },
};

const actions = {
  async fetchUnitCodes({ state, commit }, payload) {
    const request = typeof payload === "string" ? { type: payload } : payload;
    const type = request?.type;
    if (!type) return [];

    if (state.unitCodes[type]) {
      return state.unitCodes[type];
    }

    const response = await axiosInstance.get(api.global.unitCodes.list(), { params: { type } });
    const unitCodes = response.data.map((u) => ({ value: u.code, label: `${u.name}`, group: u.group, factor: u.factor }));
    commit("setUnitCodes", { type, unitCodes });
    return unitCodes;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
